import React from 'react';

const Rules: React.FC = () => {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <div className="container mx-auto py-8 md:py-12">
        <h1 className="text-3xl md:text-4xl font-bold text-center mb-8">
          Regras e Regulamentos
        </h1>
        <p className="text-center text-muted-foreground mb-12">
          Última atualização: 05 de Outubro de 2025
        </p>

        <div className="prose prose-invert max-w-none text-muted-foreground">
          <h2 className="text-2xl font-bold text-primary mt-8 mb-4">1. Aceitação dos Termos</h2>
          <p>
            Ao se registrar e utilizar os serviços da nossa plataforma, você concorda em cumprir
            e estar vinculado a todas as regras e regulamentos aqui estabelecidos. É sua
            responsabilidade ler e entender estes termos antes de participar de qualquer atividade.
          </p>

          <h2 className="text-2xl font-bold text-primary mt-8 mb-4">2. Elegibilidade</h2>
          <p>
            Para utilizar nossos serviços, você deve ter a idade legal para jogar em sua jurisdição
            (geralmente 18 anos ou mais). Reservamo-nos o direito de solicitar comprovação de idade
            e suspender contas que não atendam a este requisito.
          </p>

          <h2 className="text-2xl font-bold text-primary mt-8 mb-4">3. Conduta do Usuário</h2>
          <p>
            Você concorda em utilizar a plataforma de forma justa e ética. Qualquer forma de fraude,
            conluio, uso de software de terceiros não autorizado ou comportamento abusivo resultará
            na suspensão ou encerramento da conta e confisco de fundos.
          </p>
          <ul className="list-disc list-inside ml-4">
            <li>É proibido o uso de múltiplas contas.</li>
            <li>É proibido o uso de bots ou automação para jogar.</li>
            <li>É proibido o uso de linguagem ofensiva ou comportamento inadequado no chat.</li>
          </ul>

          <h2 className="text-2xl font-bold text-primary mt-8 mb-4">4. Regras de Jogos</h2>
          <p>
            Cada jogo em nossa plataforma possui suas próprias regras específicas. É sua
            responsabilidade familiarizar-se com as regras de cada jogo antes de apostar.
            As regras específicas dos jogos podem ser encontradas dentro de cada jogo ou em
            suas respectivas seções de ajuda.
          </p>
          <ul className="list-disc list-inside ml-4">
            <li><strong>Apostas Esportivas:</strong> Regras de liquidação de apostas, cancelamentos, limites.</li>
            <li><strong>Jogos de Cassino:</strong> Regras de roleta, blackjack, slots, etc.</li>
            <li><strong>Jogos Crash:</strong> Regras de multiplicadores, saques automáticos.</li>
          </ul>

          <h2 className="text-2xl font-bold text-primary mt-8 mb-4">5. Depósitos e Saques</h2>
          <p>
            Todos os depósitos e saques devem ser feitos de acordo com os procedimentos estabelecidos
            na plataforma. Reservamo-nos o direito de solicitar documentação adicional para
            verificação de identidade antes de processar saques.
          </p>
          <ul className="list-disc list-inside ml-4">
            <li>Limites mínimos e máximos de depósito e saque se aplicam.</li>
            <li>Pode haver taxas associadas a certas transações.</li>
          </ul>

          <h2 className="text-2xl font-bold text-primary mt-8 mb-4">6. Bônus e Promoções</h2>
          <p>
            Todos os bônus e promoções estão sujeitos a termos e condições específicos. É sua
            responsabilidade ler e entender esses termos antes de aceitar qualquer oferta.
            O não cumprimento dos requisitos de aposta pode resultar na perda do bônus e de quaisquer ganhos associados.
          </p>

          <h2 className="text-2xl font-bold text-primary mt-8 mb-4">7. Resolução de Disputas</h2>
          <p>
            Em caso de disputas, encorajamos os usuários a entrar em contato com nosso suporte ao cliente
            para uma resolução amigável. Se a disputa não puder ser resolvida internamente, ela será
            encaminhada para o órgão regulador competente.
          </p>

          <h2 className="text-2xl font-bold text-primary mt-8 mb-4">8. Alterações nos Regulamentos</h2>
          <p>
            Reservamo-nos o direito de alterar estes Regras e Regulamentos a qualquer momento.
            Notificaremos os usuários sobre quaisquer alterações significativas. O uso continuado
            da plataforma após tais alterações constitui sua aceitação dos novos termos.
          </p>

          <h2 className="text-2xl font-bold text-primary mt-8 mb-4">9. Contato</h2>
          <p>
            Para quaisquer dúvidas ou esclarecimentos sobre estas regras, entre em contato com
            nossa equipe de suporte.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Rules;
